// services.js - Utility functions for external services

// External services configuration
export const SERVICES_CONFIG = {
    // Formspree configuration for contact form
    // Replace this with your actual Formspree form ID in production
    contactForm: {
        endpoint: 'https://formspree.io/f/xblypklp',
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
};

/**
 * Submit contact form data to an external service
 * @param {object} formData - The form data to submit
 * @returns {Promise} - A promise that resolves with the response
 */
export const submitContactForm = async (formData) => {
    try {
        const response = await fetch(SERVICES_CONFIG.contactForm.endpoint, {
            method: SERVICES_CONFIG.contactForm.method,
            headers: SERVICES_CONFIG.contactForm.headers,
            body: JSON.stringify(formData),
        });

        if (!response.ok) {
            throw new Error(`Form submission failed: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error submitting form:', error);
        throw error;
    }
};

/**
 * Validate form data before submission
 * @param {object} formData - The form data to validate
 * @param {function} t - Translation function
 * @returns {object} - An object with isValid and errors properties
 */
export const validateContactForm = (formData, t) => {
    const errors = {};
    const { CONTACT_FORM } = require('./constants').FORM_CONFIG;
    const { NAME, EMAIL, MESSAGE } = CONTACT_FORM.FIELDS;

    // Validate name
    if (!formData[NAME] || formData[NAME].trim() === '') {
        errors[NAME] = t('contact.form.name.required');
    }

    // Validate email
    if (!formData[EMAIL] || formData[EMAIL].trim() === '') {
        errors[EMAIL] = t('contact.form.email.required');
    } else if (!/\S+@\S+\.\S+/.test(formData[EMAIL])) {
        errors[EMAIL] = t('contact.form.email.invalid');
    }

    // Validate message
    if (!formData[MESSAGE] || formData[MESSAGE].trim() === '') {
        errors[MESSAGE] = t('contact.form.message.required');
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
};
